export default __webpack_public_path__ + "static/banner-should-i-get-a-credit-card-personal-loan-6ea5c309868ab35cd3d87a4ac28ad0b3.jpg";